import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-payment-order';

const list = (merchantId, branchId, page = 1, pageSize = 10000) => {
	return Client.get(`${baseUrl}/payments`, {
		merchantId,
		branchId,
		page,
		pageSize,
	});
};

const stripeDetail = (merchantId, paymentId) => {
	return Client.get(
		`${baseUrl}/stripe/payment/${merchantId}/orderNo/${paymentId}`
	);
};

const stripeCharges = (merchantId, customerId, status) => {
	return Client.get(
		`${baseUrl}/stripe/payment/${merchantId}/customer/${customerId}`,
		{ status }
	);
};

const stripeDisputes = (merchantId, customerId) => {
	return Client.get(
		`${baseUrl}/stripe/dispute/${merchantId}/customer/${customerId}`
	);
};

export default { list, stripeDetail, stripeCharges, stripeDisputes };
